import { mCoresPrimarias, mCoresPrimariasDark } from "../constants/coresArray"
import pegarModoAtual from "../helpers/pegarModoAtual"

/**
 * Função que retorna a versão da cor primária adequada ao modo atual (claro/escuro)
 * @param {string} cCorHex - Cor hexadecimal (por exemplo "#FF0000")
 * @param {string[]} [mCoresVerificar] - Array opcional de cores hexadecimais para verificação
 * @param {string} [cCorPadrao] - Cor padrão usada se não encontrada (padrão: "#000000")
 * @returns {string} Cor primária resultante em formato hexadecimal
 */
export const pegarCorPrimaria = (cCorHex, mCoresVerificar, cCorPadrao) => {
  try {
    const cModo = pegarModoAtual()
    const mCoresPrimariasAtuais = mCoresPrimarias
    const mCoresPrimariasDarkAtuais = mCoresPrimariasDark

    // Define valores padrão caso não sejam passados
    const mCoresVerificarUsar = mCoresVerificar || mCoresPrimariasAtuais
    const cCorPadraoUsar = cCorPadrao || "#000000"

    if (!cCorHex || typeof cCorHex !== "string") {
     
      return cCorPadraoUsar
    }

    const cCorNormalizada = cCorHex.startsWith("#") ? cCorHex.toLowerCase() : `#${cCorHex.toLowerCase()}`

    // Obtém o índice da cor no array de cores 'light'
    const nIndice = mCoresVerificarUsar.findIndex((cCor) => {
      const cCorItemNormal = cCor.startsWith("#") ? cCor.toLowerCase() : `#${cCor.toLowerCase()}`
      return cCorItemNormal === cCorNormalizada
    })

    // Se a cor estiver na lista, retorna a versão apropriada com base no modo
    if (nIndice !== -1) {
      if (cModo === "dark" && mCoresPrimariasDarkAtuais[nIndice]) {
        return mCoresPrimariasDarkAtuais[nIndice]
      }
      return mCoresVerificarUsar[nIndice]
    }

    return cCorPadraoUsar
  } catch (oErro) {
    console.log("Erro ao processar cor primária:", oErro)
    return cCorPadrao || "#000000"
  }
}

export default pegarCorPrimaria
